// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vrl3","selected":"styles_selected__2xcue"};